<template>
    <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg p-6">
        <div class="flex flex-wrap items-center justify-between gap-3">
            <h3 class="text-lg font-semibold text-gray-900">Invoice history</h3>
            <a
                :href="route('billing.invoices.zip')"
                class="text-sm font-medium text-rent-risk-blue-400 hover:text-black"
            >
                Download all (ZIP)
            </a>
        </div>

        <Deferred data="invoices">
            <template #fallback>
                <div class="mt-4 space-y-3" data-test="invoices-skeleton">
                    <div v-for="n in 3" :key="n" class="h-10 animate-pulse rounded bg-gray-100"></div>
                </div>
            </template>

            <p v-if="!invoices || invoices.length === 0" class="mt-4 text-sm text-gray-500">
                No invoices yet.
            </p>

            <div v-else class="mt-4 overflow-x-auto">
                <table class="min-w-full divide-y divide-gray-200">
                    <thead>
                        <tr>
                            <th class="px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-gray-500">Date</th>
                            <th class="px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-gray-500">Description</th>
                            <th class="px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-gray-500">Amount</th>
                            <th class="px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-gray-500">Status</th>
                            <th class="px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-gray-500"></th>
                        </tr>
                    </thead>
                    <tbody class="divide-y divide-gray-100">
                        <tr v-for="invoice in invoices" :key="invoice.id">
                            <td class="px-3 py-2 text-sm text-gray-700">{{ formatDate(invoice.date) }}</td>
                            <td class="px-3 py-2 text-sm text-gray-700">{{ invoice.description || '—' }}</td>
                            <td class="px-3 py-2 text-sm text-gray-700">{{ formatAmount(invoice.amount) }}</td>
                            <td class="px-3 py-2 text-sm">
                                <span
                                    class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium capitalize"
                                    :class="invoice.status === 'paid' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'"
                                >
                                    {{ invoice.status }}
                                </span>
                            </td>
                            <td class="px-3 py-2 text-sm">
                                <a
                                    v-if="invoice.pdf_url"
                                    :href="invoice.pdf_url"
                                    target="_blank"
                                    rel="noopener"
                                    class="font-medium text-rent-risk-blue-400 hover:text-black"
                                >
                                    PDF
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </Deferred>
    </div>
</template>

<script>
import { Deferred } from '@inertiajs/vue3';

export default {
    name: 'InvoiceHistoryCard',
    components: {
        Deferred,
    },
    props: {
        invoices: {
            type: Array,
            default: () => [],
        },
    },
    methods: {
        formatDate(date) {
            return date ? new Date(date).toLocaleDateString() : '—';
        },
        formatAmount(amount) {
            return `$${Number(amount || 0).toFixed(2)}`;
        },
    },
};
</script>
